import ElementList from "./src/list.js";
import Banner from "./src/banner.js";
import ItemStatistic from "./src/itemstatistic.js";
import CitrusCommonPagination from "./src/commonPagination.js";
import MainPage from "./src/app.js";
import CatalogSort from "./src/sort.js";
import {Vue} from "ui.vue";

Vue.component("ElementList", ElementList);
Vue.component("Banner", Banner);
Vue.component("ItemStatistic", ItemStatistic);
Vue.component("CitrusCommonPagination", CitrusCommonPagination);
Vue.component("CatalogSort", CatalogSort);

export {ElementList, Banner, ItemStatistic, CitrusCommonPagination, MainPage};

